import React from 'react';
import OthersUserfeedList from '../userfeeds/others_userfeed_list';
import CommunityUserfeedList from '../userfeeds/community_userfeed_list';

const FeedList = ({ currentUser, hashedCompanyId = null, companyId = null, circleId = null, hasDepartments = null }) => {
  return (
    <React.Fragment>
      {companyId && !circleId && !hasDepartments ? 
      (
        CommunityUserfeedList({currentUser, companyId, hashedCompanyId})
      ) : hasDepartments ? (
        CommunityUserfeedList({ currentUser, companyId, hashedCompanyId, hasDepartments })
      ) : (
        OthersUserfeedList({ currentUser, companyId, hashedCompanyId, circleId})
      )}
    </React.Fragment>
  );
};

export default FeedList;